export default "__VITE_ASSET__xV60$Cd1__"